"use client";

import { observer } from "mobx-react-lite";

import { DocumentPage } from "@/components/doc/DocumentPage";
import { useDoc } from "@/utils/useDoc";

import type { Document } from "@/api";
import type { JSX } from "react";

type Props = {
  docId: string;
  prefetchedDoc?: Document;
  /** The server-rendered document, shown until the Yjs document syncs. */
  ssrHtml?: string;
};

export const DocPage = observer(function DocPage({
  docId,
  prefetchedDoc,
  ssrHtml,
}: Props): JSX.Element {
  const { doc, error } = useDoc(docId, prefetchedDoc);

  return <DocumentPage doc={doc} error={error} docId={docId} ssrHtml={ssrHtml} />;
});
